import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/firestore'

import router from '../router';

const plant = {
    state: {
        plantList: []
    },
    mutations: {
        PLANT_LIST(state, payload) {
            state.plantList = payload
        }
    },
    actions: {
        /* eslint-disable no-unused-vars */
        getPlants({commit}) {
            firebase.firestore().collection('plants').get().then(snapshot => {
                let plants = []
                snapshot.forEach(doc => plants.push(doc.data()))
                commit('PLANT_LIST', plants)
            }).catch(() => {
                commit('PLANT_LIST', [])
            })
        },
        applyPlant({commit}, plant) {
            // Get document reference
            let plantsRef = firebase.firestore().collection('plants').doc(plant.uuid);

            plantsRef.get().then(doc => {
                // Create or update document
                if (!doc.exists) {
                    plantsRef.set(plant);
                } else {
                    plantsRef.update(plant)
                }

                router.push({name: 'Plants'})
            })
        },
        deletePlant({state, commit}, plantId) {
            firebase.firestore().collection('plants').where('uuid', '==', plantId).get().then(snapshot => {
                snapshot.forEach(plantDoc => {
                    firebase.firestore().collection('plants').doc(plantDoc.id).delete().then(() => {
                        let plants = state.plantList.filter(plant => {
                            return plant.uuid != plantId
                        })
                        commit('PLANT_LIST', plants)
                    })
                })
            })
        }
    },
    getters: {
        plantList(state) {
            return state.plantList
        }
    }
}

export default plant
